import AccountDeletionRecoveryPage from "../../user-cabinet/pages/account-deletion-recovery-page";
import {useTranslation} from "react-i18next";
import {AuthForm, type AuthMode} from "./auth-form";
import {EmailConfirm} from "./email-confirm";
import {PasswordReset} from "./password-reset";
import {PhoneRecovery} from "./phone-recovery";
import {authDestination} from "../booking-return";

interface AuthPageProps {
  passwordResetToken?: string;
}

export function AuthPage({passwordResetToken}: AuthPageProps) {
  const {t} = useTranslation();
  if (window.location.pathname === "/auth/account-deletion") return <AccountDeletionRecoveryPage />;
  if (window.location.pathname === "/auth/email/confirm") {
    return <EmailConfirm />;
  }
  if (window.location.pathname === "/phone-recovery") {
    return <PhoneRecovery />;
  }
  if (window.location.pathname === "/auth/password/reset") {
    return <div className="standalone-auth"><a className="brand-link" href="/">{t("common.brand")}</a><PasswordReset emailToken={passwordResetToken ?? ""} /></div>;
  }
  if (window.location.pathname === "/forgot-password") {
    return <div className="standalone-auth"><a className="brand-link" href="/">{t("common.brand")}</a><PasswordReset /></div>;
  }
  const mode: AuthMode = window.location.pathname === "/signin" ? "signin" : "signup";
  const passwordResetComplete = mode === "signin" && new URLSearchParams(window.location.search).get("password_reset") === "1";
  const destination = authDestination(window.location.search);
  return <div className="standalone-auth"><a className="brand-link" href="/">{t("common.brand")}</a><AuthForm initialMode={mode} passwordResetComplete={passwordResetComplete} onAuthenticated={() => window.location.assign(destination)} /></div>;
}
